import React, { FC } from "react";
import { Id } from "../../../types";
import { useMachine } from "@xstate/react";
import { fetchMachine } from "../../../machines/fetch";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { activeSubscriptionIdState, orgUnitsState } from "../../../atoms";
import { Button, useToast } from "@chakra-ui/react";
import { deleteOrgUnit } from "3.0/api/delete-org-unit";

type Props = {
  id: Id;
  onSuccess: () => void;
};

export const DeleteOrgUnit: FC<Props> = (props) => {
  const { id, onSuccess } = props;

  const toast = useToast();

  const activeSubscriptionId = useRecoilValue(activeSubscriptionIdState);
  const setOrgUnits = useSetRecoilState(orgUnitsState);

  const [state, send] = useMachine(fetchMachine, {
    services: {
      fetch: () =>
        deleteOrgUnit({ id, subscriptionId: activeSubscriptionId as Id }),
    },

    actions: {
      success: (_, event: any) => {
        setOrgUnits(event.data.orgUnits);
        onSuccess();
        toast({
          title: "organisatie-eenheid verwijderd",
          status: "success",
          isClosable: true,
        });
      },

      failure: (_, event: any) => {
        toast({
          title: "verwijderen van organisatie-eenheid niet gelukt",
          description: JSON.stringify(event.data, null, 2),
          status: "error",
          isClosable: true,
        });
      },
    },
  });

  return (
    <Button
      type="submit"
      size="sm"
      isLoading={state.matches("loading")}
      onClick={() => {
        send(state.matches("failure") ? "RETRY" : "FETCH");
      }}
    >
      bevestig
    </Button>
  );
};
